import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui"; //element-ui的全部组件
import "element-ui/lib/theme-chalk/index.css";
import i18n from "./i18n/index.js";
import VueAwesomeSwiper from "vue-awesome-swiper";
import  {MessageBox, Message,} from "element-ui";
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);

Vue.prototype.$axios = axios;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$message = Message;

Vue.prototype.widthCheck = function (str, len = 0, type = "mark") {
  if (type !== "normal") str = str.replace(/(^\s*)|(\s*$)/g, "");
  if (type === "mark") {
    str = str.replace(/[^\w\u4E00-\u9FA5]/g, "");
  } else if (type === "tel") {
    str = str.replace(/[^\d]/g, "");
  }
  if (len > 0) {
    let temp = 0;
    for (let i = 0; i < str.length; i++) {
      if (/[\u4e00-\u9fa5]/.test(str[i])) {
        temp += 2;
      } else {
        temp += 1;
      }
      if (temp > len * 2) {
        str = str.substr(0, i);
      }
    }
  }
  return str;
};
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

